module.exports = __webpack_public_path__ + "static/img/brokenphoto.a2f10e1f.png";